import * as React from 'react';
import get from 'lodash/get';
import { makeStyles } from '@material-ui/core/styles';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Container from '@material-ui/core/Container';
import { Button } from '@material-ui/core';
import { useNavigationLinksContext } from 'contexts/navigationLinksContext';

const useStyles = makeStyles((_theme) => ({
  root: {
    marginTop: 40,
    marginBottom: 20,
  },
}));

export default function BasicBreadcrumbs() {
  const classes = useStyles();
  const navigationLinks = get(
    useNavigationLinksContext(),
    'navigationLinks',
    []
  );
  const handleNavigationClick = get(
    useNavigationLinksContext(),
    'handleNavigationClick',
    () => {}
  );

  return (
    <Container maxWidth='lg' className={classes.root}>
      <div role='presentation'>
        <Breadcrumbs aria-label='breadcrumb'>
          <Button underline='hover' color='inherit' href='/' key='home'>
            Home
          </Button>
          {navigationLinks?.map((navigationItem, index) => (
            <Button
              underline='hover'
              color='inherit'
              key={navigationItem.name}
              href={`/${navigationItem.type}/${navigationItem.slug}`}
              onClick={() => handleNavigationClick(index)}
            >
              {navigationItem.name}
            </Button>
          ))}
        </Breadcrumbs>
      </div>
    </Container>
  );
}
